<div fxLayout="row" fxLayoutGap="5%" fxLayoutAlign="start strech" *ngIf="enableDebug === true && requestID">
    <p>DEBUG</p>
    <p>
        <a [href]="buildUrlPMS()" target="_blank">PMS LOG</a>
    </p>

    <p>
        <a [href]="buildUrlMPS()" target="_blank">MPS LOG</a>
    </p>
</div>